var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLine2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 638,
    viewBox: "0 0 237 638",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3346 10.6663C21.3346 16.5573 16.559 21.333 10.668 21.333C4.77693 21.333 0.001297 16.5573 0.001297 10.6663C0.001297 4.77525 4.77693 -0.000378609 10.668 -0.000378609C16.559 -0.000378609 21.3346 4.77525 21.3346 10.6663ZM21.3346 626.574C21.3346 632.465 16.559 637.241 10.668 637.241C4.77693 637.241 0.001297 632.465 0.001297 626.574C0.001297 620.683 4.77693 615.908 10.668 615.908C16.559 615.908 21.3346 620.683 21.3346 626.574ZM10.668 10.6663L10.6098 8.66713C86.443 6.45994 143.14 43.7472 180.742 100.854C218.299 157.892 236.847 234.724 236.667 311.98C236.486 389.241 217.575 467.159 179.951 526.392C142.296 585.673 85.8323 626.303 10.7284 628.573L10.668 626.574L10.6075 624.575C84.1176 622.353 139.473 582.657 176.575 524.248C213.706 465.791 232.488 388.656 232.667 311.971C232.846 235.282 214.42 159.275 177.401 103.053C140.426 46.8998 84.9439 10.5053 10.7262 12.6654L10.668 10.6663Z",
    fill: "url(#paint0_linear_11766_28482)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11766_28482",
    x1: 122.668,
    y1: 10.5742,
    x2: 122.668,
    y2: 626.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#809ECA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine2);
export default __webpack_public_path__ + "static/media/line2.e09809ae8f1a8675b047cb7db87fe5f0.svg";
export { ForwardRef as ReactComponent };